/**
 * Every edge-function call runs next to the database.
 *
 * Supabase runs a function in the region nearest the caller unless told otherwise, and ours query the database
 * (us-east-1) several times a request: from India one ran in Mumbai and crossed the ocean for each query. Measured from
 * India on 2026-10-22, the staging `health` function took 1.1–2.4 s unpinned (ap-south-1) and 0.49–0.58 s pinned.
 *
 * The pin is Supabase's `forceFunctionRegion` query parameter, not its `x-region` header: a new request header would
 * have to be in every function's CORS allow-list. https://supabase.com/docs/guides/functions/regional-invocation
 */
export const FUNCTION_REGION = "us-east-1";
export const FUNCTION_REGION_PARAM = "forceFunctionRegion";

const FUNCTIONS_PATH = "/functions/v1/";

/** `url` pinned to the database's region when it is an edge-function URL; any other URL as it was. */
export function inFunctionRegion(url: string): string {
  const parsed = new URL(url);
  if (!parsed.pathname.startsWith(FUNCTIONS_PATH)) return url;
  parsed.searchParams.set(FUNCTION_REGION_PARAM, FUNCTION_REGION);
  return parsed.toString();
}

/**
 * The Supabase client's fetch: every request as it was, but an edge-function one pinned. supabase-js sends
 * `functions.invoke` through it; auth, PostgREST and Storage pass through untouched.
 */
export const fetchInFunctionRegion: typeof fetch = (input, init) =>
  fetch(input instanceof Request ? new Request(inFunctionRegion(input.url), input) : inFunctionRegion(String(input)), init);
